import BaseService from '@/ecm/common/BaseService.js'

class ParameterService {
  baseUrl = 'parameter';

  getAll = () => BaseService.get({ url: `${this.baseUrl}/get-all` });
  save = (parameters) => BaseService.post({ url: `${this.baseUrl}/save`, data: parameters });
  getLog = (filter) => BaseService.post({ url: `${this.baseUrl}/get-log`, data: filter });
}

export default new ParameterService()
